module.exports = __webpack_public_path__ + "img/index_quxian.92224b5.d4149913.svg";